import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import PromoCode from 'components/_special/PromoCode'
import { COUNTRIES_WITH_DYNAMIC_DISCOUNT } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import { Col, RowIndented } from 'styles/components/layout'

import CartSumBlock from './components/CartSumBlock'
import { BoxBaseStyled } from './styles'

const { DYNAMIC_DISCOUNT_PROMO } = process.env.localization
/**
 * CartSummary
 *
 * @param {object} props - properties of component
 * @returns {node} CartSummary
 */
const CartSummary = ({
  cart,
  texts,
  submitPromocode,
  closePromocode,
  isLoading,
}) => {
  const { promo, isOrderCollected } = cart
  const { dict, sales, locale } = useContext(LocalizationContext)

  const hidePromoField = React.useMemo(
    () =>
      COUNTRIES_WITH_DYNAMIC_DISCOUNT.includes(locale) &&
      cart.sum.amount > 1 &&
      promo.name === DYNAMIC_DISCOUNT_PROMO,
    [locale, cart.sum, promo],
  )

  return (
    <BoxBaseStyled>
      <RowIndented
        indent={{ xs: 0, md: 0, lg: 0 }}
        justifyContent={{ md: 'flex-end' }}
      >
        <Col width={{ xs: 1, md: 6 / 12, lg: 3 / 12 }}>
          {!sales.isPromoHidden && !hidePromoField && (
            <PromoCode
              key={locale}
              promocodeId={promo.id}
              isFetching={promo.isFetching || isOrderCollected}
              submitErrors={cart.promo.errors.submitErrors}
              errorCode={cart.promo.errors.errorCode}
              texts={texts.promocode}
              buttonTitle={dict.buttons.enter}
              inputName="promocode"
              handleSubmit={submitPromocode}
              handleClose={closePromocode}
              isDisabled={sales.isPromoDisabled}
            />
          )}
        </Col>
        <Col width={{ xs: 1, md: 5 / 12, lg: 3 / 12 }}>
          <CartSumBlock
            cart={cart}
            textsTotal={texts.total}
            isLoading={isLoading}
          />
        </Col>
      </RowIndented>
    </BoxBaseStyled>
  )
}

CartSummary.propTypes = {
  /** Object of cart state */
  cart: PropTypes.object.isRequired,

  /** Function to reset promocode state when close input */
  closePromocode: PropTypes.func.isRequired,

  /** Function to submit promocode */
  submitPromocode: PropTypes.func.isRequired,

  /** Localized texts for cart page */
  texts: PropTypes.object.isRequired,

  /** Is something about prices are loading */
  isLoading: PropTypes.bool,
}

CartSummary.defaultProps = {}

export default CartSummary
